export default "__VITE_ASSET__CN2VWSch__"